module.exports = __webpack_public_path__ + "static/media/10_of_hearts.c6339410.svg";